document.addEventListener('cart:update', (event) => {
  const data = event.detail?.data;
  const link = document.querySelector('.vbm-cart');
  if (!link || data?.didError) return;
  if (data?.source === 'product-form-component') {
    window.location.assign(link.href);
    return;
  }
  const count = event.detail?.resource?.item_count;
  if (typeof count === 'number') {
    const label = link.getAttribute('aria-label')?.replace(/\s*\(\d+\)$/, '') || '';
    link.setAttribute('aria-label', `${label} (${count})`);
    const badge = link.querySelector('span');
    if (badge) badge.textContent = String(count);
  }
});
